export default "__VITE_ASSET__47524f9f__"